import { ProductTimeSpan } from './product-time-span';
import { AreaItem } from './area-item';
import { groupBy } from './utils';
import { BookingOrderService } from '../services/booking-order.service';

export class TimeStampsCache {
  private _timeStamps: ProductTimeSpan[] = [];
  selectedProductTimeSpan: ProductTimeSpan = null;

  constructor(
    bookingOrderService: BookingOrderService
  ) {
  }

  get productTimeSpans(): ProductTimeSpan[] {
    return this._timeStamps;
  }

  reset() {
    this._timeStamps = [];
    this.selectedProductTimeSpan = null;
  }

  updateTimeSpans(areaItems: AreaItem[]) {
    if (areaItems == null) {
      return;
    }

    if (!areaItems || areaItems.length === 0) {
      this.reset();
    }

    const groups = groupBy(areaItems, 'minutes');
    const minutes = Object.keys(groups)
      .map(x => parseInt(x, 10)).sort((a: number, b: number) => b - a);
    this._timeStamps = minutes.map(x => new ProductTimeSpan(x));

    if (this.selectedProductTimeSpan != null) {
      const items = this._timeStamps.filter(x => x.timeSpan === this.selectedProductTimeSpan.timeSpan);
      if (items.length > 0) {
        this.selectedProductTimeSpan = items[0];
      }
    } else if (this._timeStamps.length) {
      const availableTimeStamps = this._timeStamps.filter(x => x.isCapacityAvailable);
      if (availableTimeStamps.length) {
         this.selectedProductTimeSpan = availableTimeStamps[0];
      }
    } else {
      console.error('updateTimeSpans. Error.');
      this.selectedProductTimeSpan = null;
    }
  }
}
